import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface VideoSegmentInitialState {
  auditLogsHeartbeatStarted: boolean
  auditLogsCompleteData: any
}

const initialState: VideoSegmentInitialState = {
  auditLogsHeartbeatStarted: false,
  auditLogsCompleteData: {
    video_url: "video_na",
    widget_code: "video_segmentation",
    action_performed: null,
    payload: {
      seg_id: "segment_no",
      input_params_obj: {
        video_url: "video_na",
        summary_length: "detailed",
        custom_instructions: null,
      },
      assessment_obj: {},
      blob_uri: {
        complete_blob_uri: [],
        generated_blob_uri: [],
        uploaded_blob_uri: [],
        downloaded_blob_uri: [],
      },
      interaction: {},
      interactions: [],
      compute_time: 0,
      tokens_used: 0,
      cache_hit: true,
      session_timeout: false,
      usage_time_in_sec: 0,
      watch_percentage: 0,
      video_duration: 0,
    },
  },
}

const VideoSegmentSlice = createSlice({
  name: "video-segment",
  initialState,
  reducers: {
    setAuditLogsHeartbeatStarted: (state, action: PayloadAction<boolean>) => {
      state.auditLogsHeartbeatStarted = action.payload
    },
    setAuditLogsCompleteData: (state, action: PayloadAction<any>) => {
      state.auditLogsCompleteData = action.payload
    },
    resetState: () => initialState,
  },
})

export const { resetState, setAuditLogsHeartbeatStarted, setAuditLogsCompleteData } = VideoSegmentSlice.actions

export default VideoSegmentSlice.reducer
